import { render, staticRenderFns } from "./index_f.vue?vue&type=template&id=14687640&scoped=true"
import script from "./index_f.vue?vue&type=script&lang=js"
export * from "./index_f.vue?vue&type=script&lang=js"
import style0 from "./index_f.vue?vue&type=style&index=0&id=14687640&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14687640",
  null
  
)

export default component.exports